module.exports = __webpack_public_path__ + "media/project_quote/download-file-3f9e353e.png";